export enum WorkTimeTypes {
	'PartTimeWork' = 'П', // подработка
	'Attendance' = 'Я', // явка
	'UnexcusedAbsences' = 'НН', // неявка по невыясненным причинам
	'WeekendsAndHolidays' = 'В', // выходные и праздничные дни
	'SickLeave' = 'Б', // больничный лист
	'AnnualPaidLeave' = 'ОТ', // ежегодные основной оплачиваемый отпуск
	'Dismissed' = 'УВ', // уволен
}

export const WorkTimeTypeDescriptions: Record<keyof typeof WorkTimeTypes, string> = {
	PartTimeWork: 'подработка',
	Attendance: 'явка',
	UnexcusedAbsences: 'неявка',
	WeekendsAndHolidays: 'выходной',
	SickLeave: 'больничный',
	AnnualPaidLeave: 'отпуск',
	Dismissed: 'уволен',
};
